import {Directive, ElementRef, HostListener, Output, EventEmitter} from '@angular/core';

@Directive({
    selector: '[appClickOutside]'
})
export class ClickOutsideDirective {

    @Output() clickOutside: EventEmitter<any> = new EventEmitter();

    constructor(private elementRef: ElementRef) {
    }

    @HostListener('document:click', ['$event.target'])
    onClick(targetElement) {
        const clickedInside = this.elementRef.nativeElement.contains(targetElement);

        if (!clickedInside) {
            this.clickOutside.emit(targetElement);
        }
    }
}
